// JS bridge for environment configuration
// Kept in JS so Create React App (JS projects) can import without TypeScript support.
export const environment = {
  takeDataFrom: "LOCAL", // "LOCAL" or "VPS"
};
